// src/pages/Enseignants/ListingAdherents/components/ListingAdherentsDashboardHeader.jsx

import React from "react";
import {
  FaMobileAlt,
  FaSyncAlt,
  FaUserFriends,
  FaBolt,
} from "react-icons/fa";

export default function ListingAdherentsDashboardHeader({ loading, onRefresh }) {
  return (
    <div className="bg-gradient-to-r from-blue-500 via-violet-500 to-pink-500">
      <div className="px-5 py-6 text-white sm:px-8">
        <div className="mx-auto max-w-4xl text-center">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-1 text-xs font-bold uppercase tracking-wide ring-1 ring-white/20">
            <FaMobileAlt />
            Vue terrain enseignants
          </div>

          <h1 className="mt-4 text-2xl font-bold sm:text-3xl">
            Listing visuel des adhérents
          </h1>

          <p className="mx-auto mt-2 max-w-3xl text-sm leading-6 text-white/90">
            Accédez rapidement à la fiche d’un adhérent depuis votre smartphone :
            photo, groupes, statut, blessure, notes enseignant et actions rapides.
          </p>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-3">
            <button
              type="button"
              onClick={onRefresh}
              disabled={loading}
              className="inline-flex items-center gap-2 rounded-xl bg-white/15 px-4 py-2 text-sm font-bold text-white ring-1 ring-white/20 transition hover:bg-white/25 disabled:opacity-60"
            >
              <FaSyncAlt className={loading ? "animate-spin" : ""} />
              Actualiser
            </button>

            <div className="inline-flex items-center gap-2 rounded-xl bg-white/15 px-4 py-2 text-sm font-bold text-white ring-1 ring-white/20">
              <FaUserFriends />
              Cards adhérents
            </div>

            <div className="inline-flex items-center gap-2 rounded-xl bg-white/15 px-4 py-2 text-sm font-bold text-white ring-1 ring-white/20">
              <FaBolt />
              Actions rapides
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}